import {
  Level,
  UserWorkoutSession,
} from 'fitbeat.gym-core';
import { CardioOrResistance } from 'fitbeat.models';
import ChevronRight from 'fitbeat.react-native-components/assets/images/chevron-right-orange.svg';
import GlobeOutline from 'fitbeat.react-native-components/assets/images/globe-outline.svg';
import momentTimeZone from 'moment-timezone';
import React from 'react';
import { StyleSheet, Text, View } from 'react-native';
import Theme from '../theme';
import { getSkillLevelText, getSlotTime, getWorkoutTypeText } from '../utils';
import { defaultScale } from '../utils/scaling';

const getWorkoutDescription = (
  type: CardioOrResistance,
  level: Level,
): string => {
  return `${getSkillLevelText[level]} ${getWorkoutTypeText[type]} `;
};
interface IProps {
  userWorkoutSessions: UserWorkoutSession[];
  isFirstTile: boolean;
  isLastTile: boolean;
  key: string;
}

export const InfluencerWorkoutTile = ({
  userWorkoutSessions,
  isFirstTile,
  isLastTile,
}: IProps) => {
  const timezone = momentTimeZone.tz.guess();
  const timeOfFirstExercise = momentTimeZone(
    userWorkoutSessions[0].startTimeOfFirstExercise,
  ).tz(timezone);
  const bookingDay = timeOfFirstExercise.format('ddd');
  const bookingDate = timeOfFirstExercise.format('DD MMM');
  const offset = timeOfFirstExercise.format('Z');
  return (
    <>
      {isFirstTile && (
        <View style={styles.timeZoneInfo}>
          <GlobeOutline />
          <Text style={styles.timezoneText}>{`Timezone UTC${offset}`}</Text>
        </View>
      )}
      <div className='influencer-booking-tile'>
        <div className='influencer-booking-date-container'>
          <div className='influencer-booking-day-text'>{bookingDay}</div>
          <div className='influencer-booking-date-text'>{bookingDate}</div>
        </div>
        <div className='influencer-booking-workout-card-container'>
          {userWorkoutSessions.map((userWorkoutSession, index) => {
            const workoutCardClassNames = `influencer-booking-workout-card ${
              index + 1 < userWorkoutSessions.length
                ? 'influencer-booking-workout-card-margin-bottom'
                : ''
            }`;

            const bookingTime = momentTimeZone(
              userWorkoutSession.startTimeOfFirstExercise,
            )
              .tz(timezone)
              .format('HH:mm');

            const duration = getSlotTime(userWorkoutSession);
            const level = userWorkoutSession.settings.level;
            const cardioOrResistance =
              userWorkoutSession.settings.cardioOrResistance;
            return (
              <a
                className={workoutCardClassNames}
                key={index}
                href={userWorkoutSession.openInviteLink}
                target={'_blank'}
              >
                <Text
                  style={styles.timeText}
                >{`${bookingTime} | ${duration}`}</Text>
                <View style={styles.verticalSeparator} />
                <Text style={styles.workoutDescriptionText}>
                  {getWorkoutDescription(cardioOrResistance, level)}
                </Text>
                <ChevronRight
                  fill={Theme.PRIMARY}
                  width={defaultScale(10)}
                  height={defaultScale(11)}
                />
              </a>
            );
          })}
        </div>
      </div>
      {!isLastTile && <View style={styles.horizontalSeparator} />}
    </>
  );
};

const styles = StyleSheet.create({
  timeText: {
    ...Theme.textStyle.bodyCopyBold,
    width: '38%',
  },
  timezoneText: {
    ...Theme.textStyle.small,
    marginHorizontal: defaultScale(10),
  },
  workoutDescriptionText: {
    ...Theme.textStyle.small,
    flex: 1,
  },
  verticalSeparator: {
    backgroundColor: Theme.GREY_FIGMA_MEDIUM,
    width: defaultScale(1),
    height: defaultScale(35),
    marginHorizontal: defaultScale(10),
  },
  horizontalSeparator: {
    height: defaultScale(5),
    width: '100%',
    alignSelf: 'center',
    backgroundColor: Theme.GREY_FIGMA,
  },
  timeZoneInfo: {
    flexDirection: 'row',
    justifyContent: 'flex-end',
    marginTop: defaultScale(10),
  },
});
